<template>
    <div :class="$style.content">
        <img
            v-if="!$slots.image"
            :src="props.image"
            :class="$style.image"
            :alt="props.title"
        />
        <slot name="image" />
        <div :class="$style.label_container">
            <Typography
                type="label"
                size="l"
                semibold
                :class="$style.title"
                :responsive="false"
            >
                {{ props.title }}
            </Typography>
            <Typography
                v-if="props.description"
                type="paragraph"
                size="s"
                :class="$style.description"
                :responsive="false"
            >
                {{ props.description }}
            </Typography>
        </div>
        <slot />
    </div>
</template>

<script setup lang="ts">
import Typography from '@/components_new/Typography.vue'

const props = defineProps<{
    image?: string
    title: string
    description?: string
}>()
</script>
<style module>
.content {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 16px;
    border-radius: 24px;
    background: rgba(23, 23, 26, 0.9);
    padding: 20px 16px 16px 16px;
    width: 280px;
    backdrop-filter: blur(8px);
}

.image {
    width: 120px;
    border-radius: 24px;
}

.label_container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
}

.title {
    text-align: center;
}

.description {
    color: rgba(255, 255, 255, 0.6);
    text-align: center;
}
</style>
